var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18182 0H0.818182C0.601264 0.00024939 0.393303 0.0854253 0.239919 0.236843C0.0865348 0.388261 0.000252629 0.593556 0 0.807692V13.1923C0.000252629 13.4064 0.0865348 13.6117 0.239919 13.7632C0.393303 13.9146 0.601264 13.9998 0.818182 14H5.18182C5.39874 13.9998 5.6067 13.9146 5.76008 13.7632C5.91347 13.6117 5.99975 13.4064 6 13.1923V0.807692C5.99975 0.593556 5.91347 0.388261 5.76008 0.236843C5.6067 0.0854253 5.39874 0.00024939 5.18182 0ZM4.90909 12.9231H1.09091V1.07692H4.90909V12.9231Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1818 0H8.81818C8.60126 0.00024939 8.3933 0.0854253 8.23992 0.236843C8.08654 0.388261 8.00025 0.593556 8 0.807692V13.1923C8.00025 13.4064 8.08654 13.6117 8.23992 13.7632C8.3933 13.9146 8.60126 13.9998 8.81818 14H13.1818C13.3987 13.9998 13.6067 13.9146 13.7601 13.7632C13.9135 13.6117 13.9997 13.4064 14 13.1923V0.807692C13.9997 0.593556 13.9135 0.388261 13.7601 0.236843C13.6067 0.0854253 13.3987 0.00024939 13.1818 0ZM12.9091 12.9231H9.09091V1.07692H12.9091V12.9231Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPause);
export default ForwardRef;